import React from 'react';
import clsx from 'clsx';
import DataCard from './DataCard';
import NoPageSelectedValidation from '../ViewPageFlow/NoPageSelectedValidation';

const DataModelCanvas = ({ selectedProject, selectedPage }) => {
  const { data: dataModel = [], services = [] } =
    selectedPage > -1
      ? JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage]
      : {};
  return (
    <div
      className={clsx('blueBorderStyle', 'flexPropsDataCanvas')}
      style={{ backgroundColor: 'white' }}
    >
      <div
        style={{
          height: 'auto',
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
          overflowY: 'auto'
        }}
      >
        {selectedPage > -1 &&
          dataModel.map((data) => (
            <DataCard key={data.dataName} data={data} selectedProject={selectedProject} />
          ))}
        {selectedPage > -1 ? (
          services.map((data) => (
            <DataCard key={data.dataName} data={data} selectedProject={selectedProject} isService />
          ))
        ) : (
          <NoPageSelectedValidation />
        )}
      </div>
    </div>
  );
};

export default DataModelCanvas;
